import Enums from "../../../enums/enums";
import helper from "../../../helper/shareHelper";
import i18n from "../../../locales/i18n";
import * as api from "../../../service/ApiSevice";
import { gtagEventRegister } from "../../../service/analytics/gtagEvent/gtagEvent";
import store from "../../baseController";

export const actions = {
  RegisterEmail({ commit, state }, registerTemplate) {
    if (state.registerLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Loading);
      const encpw = helper.CreateToken(registerTemplate.password.value);
      let userProfileModel = {
        id: 0,
        username: registerTemplate.email.value,
        password: encpw,
        displayName: registerTemplate.firstName.value,
        firstName: registerTemplate.firstName.value,
        lastName: registerTemplate.lastName.value,
        phone: registerTemplate.telephone.value,
        referrerUserId: registerTemplate.referrerUserId,
        invitationId: registerTemplate.invitationId,
        invitationCode: registerTemplate.invitationCode,
        userRegisterOptionModel: {
          birthDate: !isNaN(new Date(registerTemplate.birthday.value).getDate())
            ? registerTemplate.birthday.value
            : new Date(null),
          position: registerTemplate.position.value.value,
          positionOther: registerTemplate.addposition.value,
          department: registerTemplate.department.value.value,
          departmentOther: registerTemplate.adddepartment.value,
          file: registerTemplate.imageProfile,
        },
      };

      api.UserService.DoRegister(userProfileModel).then((res) => {
        if (res.res.responseCode.IsSuccess()) {
          commit("MutationRegister", registerTemplate);
          let registerModel = {
            userId: res.res.insertedUser.userId,
            uuId: res.res.insertedUser.uuId,
            loginModel: {
              username: registerTemplate.email.value,
              password: registerTemplate.password.value,
              userType: Enums.userType.email,
              language: i18n.locale,
              register: true,
            },
          };
          gtagEventRegister(registerModel.uuId);
          commit("MutationSetRegisterModel", registerModel);
          commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoAcceptInvitation({ commit, state }, input) {
    if (state.acceptInvitationLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetAcceptInvitationLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoAcceptInvitation(input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetAcceptInvitationModel", res.data.invitationModel);
            commit("MutationSetAcceptInvitationLoadingStatus", Enums.LoadingStatusType.Success);
          }
        })
        .catch((error) => error);
    }
  },
  DoAcceptInvitationV2({ commit, state }, input) {
    if (state.acceptInvitationLoadingStatusV2 !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetAcceptInvitationLoadingStatusV2", Enums.LoadingStatusType.Loading);
      api.UserService.DoAcceptInvitationV2(input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetAcceptInvitationModelV2", res.data.invitationModel);
            commit("MutationSetAcceptInvitationLoadingStatusV2", Enums.LoadingStatusType.Success);
          }
        })
        .catch((error) => error);
    }
  },
  DoGetInvitationInRole({ commit, state }, input) {
    if (state.getUserSenderInvitationDetailLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationGetInvitationInRoleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoGetInvitationInRole(input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationGetInvitationInRoleLoadingStatus", Enums.LoadingStatusType.Success);
            commit("MutationGetInvitationInRole", res.data.user);
          }
        })
        .catch((error) => error);
    }
  },
  DoInsertUserProfileConsentForRegister({ commit, state }, input) {
    if (state.insertUserProfileConsentLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetInsertUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Loading);
      let _input = helper.PrepareToInsertUserProfileConsent(input.registerModel.userId, input.isConsentTerm);
      api.UserService.DoInsertUserProfileConsent(_input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetInsertUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Success);
            store.dispatch("login_email", input.registerModel.loginModel);
          }
        })
        .catch((error) => error);
    }
  },
  DoInsertUserProfileConsent({ commit, state }, input) {
    if (state.insertUserProfileConsentLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetInsertUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Loading);
      let _input = helper.PrepareToInsertUserProfileConsent(input.userId, input.isConsentTerm);
      api.UserService.DoInsertUserProfileConsent(_input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetInsertUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Success);
            store.dispatch("login_email", input.registerModel.loginModel);
          }
        })
        .catch((error) => error);
    }
  },
  DoGetUserProfileConsent({ commit, state }, userId) {
    if (state.getUserProfileConsentLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetGetUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoGetUserProfileConsent(userId)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetGetUserProfileConsentLoadingStatus", Enums.LoadingStatusType.Success);
            commit("MutationSetUserprofileConsentModel", res.data.userprofileConsentModel);
          }
        })
        .catch((error) => error);
    }
  },
  RegisterEmailWithPartner({ commit, state }, registerTemplate) {
    if (state.registerLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Loading);
      const encpw = helper.CreateToken(registerTemplate.password.value);
      let userProfileModel = {
        id: 0,
        username: registerTemplate.email.value,
        password: encpw,
        displayName: registerTemplate.firstName.value,
        firstName: registerTemplate.firstName.value,
        lastName: registerTemplate.lastName.value,
        phone: registerTemplate.telephone.value,
        referrerUserId: registerTemplate.referrerUserId,
        invitationId: registerTemplate.invitationId,
        invitationCode: registerTemplate.invitationCode,
        userRegisterOptionModel: {
          birthDate: !isNaN(new Date(registerTemplate.birthday.value).getDate())
            ? registerTemplate.birthday.value
            : new Date(null),
          position: registerTemplate.position.value.value,
          positionOther: registerTemplate.addposition.value,
          department: registerTemplate.department.value.value,
          departmentOther: registerTemplate.adddepartment.value,
          file: registerTemplate.imageProfile,
        },
        affiliateCampaign: {
          campaignCode: registerTemplate.campaignId ? registerTemplate.campaignId : null,
          campaignName: registerTemplate.campaignName ? registerTemplate.campaignName : null,
        },
      };

      api.UserService.DoRegister(userProfileModel).then((res) => {
        if (res.res.responseCode.IsSuccess()) {
          commit("MutationRegister", registerTemplate);
          let registerModel = {
            userId: res.res.insertedUser.userId,
            uuId: res.res.insertedUser.uuId,
            loginModel: {
              username: registerTemplate.email.value,
              password: registerTemplate.password.value,
              userType: Enums.userType.email,
              language: i18n.locale,
              register: true,
            },
          };
          gtagEventRegister(registerModel.uuId);
          commit("MutationSetRegisterModel", registerModel);
          commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Success);
          if (registerTemplate.campaignId && registerModel.userId) {
            let userId = registerModel.userId;
            const dateNowStr = new Date().ToDateJsonString();

            const createUserCampaignPayload = {
              campaignCode: registerTemplate.campaignId,
              userId: userId,
              userCreateDate: dateNowStr,
              firstName: registerTemplate.firstName.value,
              lastName: registerTemplate.lastName.value,
              email: registerTemplate.email.value,
            };
            api.AffiliatesService.createUserCampaign(createUserCampaignPayload).then(() => {
              if (registerTemplate.campaignType === "REGISTER") {
                const payload = {
                  userId: userId,
                  userEmail: registerTemplate.email.value,
                  userCreateDate: dateNowStr.split("T")[0],
                  userType: registerTemplate.position.value.value,
                };
                api.AffiliatesService.actionRegister(payload);
              }
            });
          }
        } else {
          commit("MutationRegisterLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoValidateUsername({ commit, state }, username) {
    return new Promise((resolve) => {
      api.UserService.DoValidateUsername(username).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(res.data.validated);
        } else {
          resolve(false);
        }
      });
    });
  },
  DoValidateIsCanAcceptInvitation({ commit, state }, input) {
    return new Promise((resolve) => {
      api.UserService.DoValidateIsCanAcceptInvitation(input).then((res) => {
        if (
          !res.data.responseCode.IsSuccess() &&
          res.data.exception.code == Enums.PeakExceptionResponseCode.OverInvitationUser
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  GetUserSenderInvitationDetail({ commit, state }, input) {
    if (state.getUserSenderInvitationDetailLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetGetUserSenderInvitationDetailLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.GetUserSenderInvitationDetail(input)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            commit("MutationSetGetUserSenderInvitationDetailLoadingStatus", Enums.LoadingStatusType.Success);
            commit("MutationSetGetGetUserSenderInvitationDetail", res.data.senderInvitationDetail);
          }
        })
        .catch((error) => error);
    }
  },
};
